module.exports = __webpack_public_path__ + "img/gavel.cc152a05.png";